export const types = {
    READDOCUMENT: 'READ-DOCUMENT',
    ADDHEADER: 'ADD-HEADER',
    ADDPARAGRAPH: 'ADD-PARAGRAPH',
    ADDIMAGE: 'ADD-IMAGE',
    SAVE: 'SAVE'
};
